import angular from 'angular';

import {
  STICKY_CONTAINER_ID,
  STICKY_CONTAINER_FOR_COLUMN_CLONE_ID,
  STICKY_COLUMN_CLONE_CLASS,
} from '../constants';

export default function shiftsStickyContainer($compile, $window, $document) {
  'ngInject';

  return {
    scope: true,
    compile(element) {
      const rawElementHTML = element[0].outerHTML;
      const stickyHolderElement = angular.element(document.getElementById(STICKY_CONTAINER_ID));
      const stickyColumnCloneHolderElement = angular.element(
        document.getElementById(STICKY_CONTAINER_FOR_COLUMN_CLONE_ID)
      );

      return {
        post($scope, $element, $attrs) {
          const enabled = $scope.$eval($attrs.shiftsStickyContainer);

          if (!enabled) {
            return;
          }

          let clonedGroup = angular.element(`
            <div class="shifts-container shifts-group-container ng-hide" adjust-to-horizontal-scroll ng-class="group ? ctrl.getGroupClass(group) : 'manager-header-pinned'"></div>
          `);

          let cloneShown = false;

          const cloneElement = angular.element(rawElementHTML);
          cloneElement.removeAttr('shifts-sticky-container'); // prevent infinite loop

          clonedGroup.append(cloneElement);
          if ($element.closest(`.${STICKY_COLUMN_CLONE_CLASS}`)?.length) {
            if ($document[0].body.contains($element[0])) {
              stickyColumnCloneHolderElement.append(clonedGroup);
            } else {
              return;
            }
          } else {
            stickyHolderElement.append(clonedGroup);
          }

          clonedGroup = $compile(clonedGroup)($scope);
          $scope.$on('$destroy', () => {
            clonedGroup.remove();
            angular.element($window).off('scroll', refresh);
          });

          angular.element($window).on('scroll', refresh);
          $scope.$on('shiftsStickyContainer:refresh', refresh);

          refresh();

          function refresh() {
            const oldShown = cloneShown;
            let originalElementRect;

            if (!$scope.$eval($attrs.active)) {
              cloneShown = false;
            } else {
              const holderRect = stickyHolderElement[0].getBoundingClientRect();
              originalElementRect = $element[0].getBoundingClientRect();

              const height = originalElementRect.height;
              const offsetIfNotShown = oldShown ? 0 : height;
              const cloneBottom = holderRect.bottom + offsetIfNotShown;

              cloneShown = cloneBottom > originalElementRect.bottom;
            }

            if (cloneShown !== oldShown) {
              // the ng-hide class is manually toggled to maximize performance
              clonedGroup[cloneShown ? 'removeClass' : 'addClass']('ng-hide');

              if (cloneShown) {
                clonedGroup.css('width', `${originalElementRect.width}px`);
              }
            }
          }
        },
      };
    },
  };
}
